/**
 * @generated SignedSource<<037c1ac2cb59092b0384d5d4cdf1f810>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type ContentAnalyticsViewersUnifiedQuery_contentAnalyticsViewers_ContentAnalyticsViewers =
  {
    __typename?: "ContentAnalyticsViewers";
    count: number;
  };
export type ContentAnalyticsViewersUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type ContentAnalyticsViewersUnifiedQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: ContentAnalyticsViewersUnifiedQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type ContentAnalyticsViewersUnifiedQuery_Query = {
  __typename?: "Query";
  contentAnalyticsViewers: ContentAnalyticsViewersUnifiedQuery_contentAnalyticsViewers_ContentAnalyticsViewers | null;
  user: ContentAnalyticsViewersUnifiedQuery_user_AtlassianUser | null;
};
export type ContentAnalyticsViewersUnifiedQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  fromDate?: InputMaybe<Scalars["String"]["input"]>;
}>;
export type ContentAnalyticsViewersUnifiedQuery =
  ContentAnalyticsViewersUnifiedQuery_Query;
